import React from 'react';
import { Link } from 'react-router-dom';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Avatar,
    Chip,
    IconButton,
    Tooltip,
} from '@mui/material';
import { Visibility, VisibilityOff, CardMembership } from '@mui/icons-material';
import { Permissions } from '../../config';

const GroupList = ({ groups, onClick, t }) => {
    const userPermission = JSON.parse(localStorage.getItem('user')).permission;
    const canUpdate = userPermission.includes(Permissions.GROUP_UPDATE);

    const getTypeColor = (type) => {
        switch (type) {
            case 'regular':
                return '#2196f3';
            case 'lite':
                return '#4caf50';
            case 'golden':
                return '#ffc107';
            default:
                return '#9e9e9e';
        }
    };

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>{t('logo')}</TableCell>
                        <TableCell>{t('name')}</TableCell>
                        <TableCell>{t('type')}</TableCell>
                        <TableCell>{t('visibility')}</TableCell>
                        <TableCell>{t('membership_card')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {groups.map((group) => (
                        <TableRow
                            key={group.id}
                            onClick={() => canUpdate && onClick(group)}
                            style={{ cursor: canUpdate ? 'pointer' : 'default' }}
                        >
                            <TableCell>
                                <Avatar
                                    src={group.logo}
                                    alt={group.name}
                                    sx={{ width: 40, height: 40 }}
                                />
                            </TableCell>
                            <TableCell>{group.name}</TableCell>
                            <TableCell>
                                <Chip
                                    label={t(`group_type_${group.type}`)}
                                    sx={{
                                        backgroundColor: getTypeColor(group.type),
                                        color: 'white',
                                        fontWeight: 'bold',
                                    }}
                                />
                            </TableCell>
                            <TableCell>
                                <Tooltip title={group.hidden ? t('hidden') : t('visible')}>
                                    <IconButton size="small" disabled>
                                        {group.hidden ? (
                                            <VisibilityOff sx={{ color: '#f44336' }} />
                                        ) : (
                                            <Visibility sx={{ color: '#4caf50' }} />
                                        )}
                                    </IconButton>
                                </Tooltip>
                            </TableCell>
                            <TableCell>
                                <Tooltip
                                    title={
                                        group.has_membership_card
                                            ? t('has_membership_card')
                                            : t('no_membership_card')
                                    }
                                >
                                    <IconButton size="small" disabled>
                                        <CardMembership
                                            sx={{
                                                color: group.has_membership_card
                                                    ? '#2196f3'
                                                    : '#9e9e9e',
                                                opacity: group.has_membership_card ? 1 : 0.5,
                                            }}
                                        />
                                    </IconButton>
                                </Tooltip>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default GroupList;
